import { withInstall } from '@xzx-design/utils'
import _Lottie from './src/lottie.vue'

export const Lottie = withInstall(_Lottie)
export default Lottie

export * from './src/lottie'
